import { actsAsAdmin } from 'shared/lib/roles'
import { useAuthStore } from 'shared/store/auth'
import { ShiftCard } from './ShiftCard'
import { Toolbar } from './Toolbar'
import { usePointOfPage } from './use-point-of-page'

/**
 * «Смена» — the Point's Shift (spec §17; ADR-0035), the first page under «Касса»: the
 * operator opens their Shift, sees the cash taken in it, and closes it with the
 * counted drawer. The Point's Cashbox and its Cash bag are the next page,
 * «Сумка наличных» (`CashBagPage`).
 *
 * Who sees what is point-scoped by role (ADR-0029): an **operator** sees only their
 * **own Point** (the backend resolves it from their binding — no `pointId` is sent);
 * an **admin** picks any Point, watches its Shift and may close it for an operator
 * who left. The backend is the real guard.
 */
export function Money() {
	const role = useAuthStore((s) => s.user.role)
	const isAdmin = actsAsAdmin(role)
	const { locationId, scoped } = usePointOfPage()

	return scoped ? (
		<ShiftCard
			locationId={locationId}
			isOperator={role === 'operator'}
			isAdmin={isAdmin}
			toolbar={(action) => <Toolbar action={action} />}
		/>
	) : (
		<Toolbar />
	)
}
